import { createSelector } from '@reduxjs/toolkit'
import { RootState } from '../..'

const getSelectedPartner = (state: RootState) => state.partners.selectedPartnerId
const getFocussedPartnerId = (state: RootState) => state.partners.focussedPartnerId
const getApiUrls = (state: RootState) => state.partners.apiUrls

export const selectedPartnerSelector = createSelector(
    getSelectedPartner,
    selectedPartner => selectedPartner
)

export const focussedPartnerIdSelector = createSelector(
    getFocussedPartnerId,
    focussedPartnerId => focussedPartnerId
)

export const apiUrlsSelector = createSelector(
    getApiUrls,
    apiUrls => apiUrls
)
